import * as React from "react";
import classNames from "classnames";
import { WithStyles, withStyles, createStyles, Theme } from '../mui/styles';
import DataSource, { DataSourceState } from "../../data/DataSource";
import { Pagination, PaginationProps } from "../widget";
import { StyleRulesCallback } from "@material-ui/core";

export interface PaginationSettings {
    rowsPerPageOptions?: number[];
    labelRowsPerPage?: string;
    allowItemsCountInfo?: boolean;
    pageCount?: number;
    autoHide?: boolean;
}


export interface DataGridPaginationProps<T> {
    dataSource: DataSource<T>;
    dataSourceState: DataSourceState<T>;
    paginationSettings?: PaginationSettings;
    allowPaging?: boolean;
}

class DataGridPagination<T> extends React.Component<DataGridPaginationProps<T> & WithStyles<typeof styles>>{

    private getPaginationProps = (): PaginationProps => {
        const { dataSource, paginationSettings, dataSourceState } = this.props;
        const { itemsCount, pageSize, currentPage } = dataSourceState;
        const { autoHide, ...other } = paginationSettings;

        const result: PaginationProps = {
            count: itemsCount ? itemsCount : 0,
            rowsPerPage: pageSize,
            page: currentPage,
            onChangePage: dataSource.setCurrentPage,
            onChangeRowsPerPage: dataSource.setPageSize,
            ...other,
        };

        return result;
    }

    render() {
        const { allowPaging, classes, paginationSettings } = this.props;
        const pgProps = this.getPaginationProps();
        const numPages = Math.ceil(pgProps.count / pgProps.rowsPerPage);
        const show = (paginationSettings.autoHide !== true || numPages > 1) && allowPaging;

        const paginationClass = classNames({
            [classes.root]: true,
        });

        return show
            ? <div className={paginationClass}>
                <Pagination {...pgProps} />
            </div>
            : null;
    }
}




const styles = ((theme: Theme) => createStyles({
    root: {
        //borderTop: '1px solid ' + theme.palette.divider,
        //borderTop: '15px solid red',
        paddingLeft: 0,
        paddingRight: 0,
        '&:last-child': {
            padding: 0,
        }
    }
})) as StyleRulesCallback;

export default withStyles(styles)(DataGridPagination);